import { z } from 'zod';

export type ToggleEventType = 'Toggle_FeatureOptInToggled';

// Toggle event payload schemas
export const ToggleEventBaseSchema = z.object({
  feature_name: z.string(),
  feature_version: z.string().optional(),
  new_state: z.string(),
  source: z.string(),
});

export const Toggle_FeatureOptInToggledPayloadSchema = ToggleEventBaseSchema.extend({});

export type ToggleEventTypePayloadMap = {
  Toggle_FeatureOptInToggled: z.infer<typeof Toggle_FeatureOptInToggledPayloadSchema>;
};

export const ToggleEventSchemaMap = {
  Toggle_FeatureOptInToggled: Toggle_FeatureOptInToggledPayloadSchema,
};
